export default __webpack_public_path__ + "static/media/material3.a73498c3.png";